import { Component, Input, Output, EventEmitter } from '@angular/core';
import { RequestLabelEnum } from '../../../../models/requests/createLeadRequest.model';
import { menuAnimation } from '@uranda/ui';
import { ProfileService } from '../../../../auth/services/profile.service';

@Component({
  selector: 'app-label-dropdown-content',
  templateUrl: './label-dropdown-table.component.html',
  styleUrls: ['./label-dropdown-table.component.css'],
  standalone: false,
  animations: [menuAnimation]
})
export class LabelDropdownContentComponent {
  @Input() label!: RequestLabelEnum;
  @Input() data!: any;
  @Input() table: boolean = false;
  allLabels = Object.values(RequestLabelEnum);

  @Output() labelChanged = new EventEmitter<RequestLabelEnum>();

  constructor(protected profileService: ProfileService) {}

  get canEdit(): boolean {
    return this.profileService.meets('MANAGE_REQUESTS');
  }

  labelDisplay: Record<RequestLabelEnum, string> = {
    NEW: 'New',
    CONTACTED: 'Contacted',
    IN_PROGRESS: 'In Progress',
    CLOSED: 'Closed',
  };

  labelClasses: Record<RequestLabelEnum, string> = {
    NEW: 'bg-primary text-white',
    CONTACTED: 'bg-success text-white',
    IN_PROGRESS: 'bg-warning text-white',
    CLOSED: 'bg-danger text-white',
  };

  labelOptionClasses: Record<RequestLabelEnum, string> = {
    NEW: 'text-primary',
    CONTACTED: 'text-success',
    IN_PROGRESS: 'text-warning',
    CLOSED: 'text-danger',
  };

  getOptionClass(label: RequestLabelEnum): string {
    return this.labelOptionClasses[label] || 'text-secondary';
  }

  get otherLabels(): RequestLabelEnum[] {
    return this.allLabels.filter((l) => l !== this.label);
  }

  getLabelClass(label: RequestLabelEnum): string {
    return this.labelClasses[label] || 'bg-secondary text-white';
  }

  getLabelDisplay(label: RequestLabelEnum): string {
    return this.labelDisplay[label] || label;
  }

  updateLabel(option: RequestLabelEnum, event: MouseEvent) {
    event.stopPropagation();
    this.labelChanged.emit(option);
  }
}